import {ReactElement} from "react";
import {Range} from "react-range";

export interface SliderProps {
    value: number
    onChange: (value: number) => void
    step?: number
    min: number
    max: number
}

export function Slider(props: SliderProps): ReactElement {
    const rangeValue = Math.max(props.min, Math.min(props.max, props.value));

    return (
        <div className="px-3 py-5">
            <Range
                step={props.step ?? 1}
                min={props.min}
                max={props.max}
                onChange={([height]) => props.onChange(height)}
                values={[rangeValue]}
                renderTrack={({props, children}) => (
                    <div
                        {...props}
                        className="h-2 bg-gray-2 rounded-full"
                    >
                        {children}
                    </div>
                )}
                renderThumb={({props}) => (
                    <div
                        {...props}
                        className="w-8 h-8 rounded-full border bg-secondary border-gray-1"
                    />
                )}
            />
        </div>
    );
}